module.exports = __webpack_public_path__ + "static/media/1.6fc66cf9.jpg";